module.exports = __webpack_public_path__ + "img/index-img-02-btn.a199a76f.png";